import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {getHandlingOverview} from "../../../api/static/StaticRequestService";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addMonths} from "date-fns";
import {CustomTable, CustomTh, SubContainer} from "../../lifecycle/rentalAsset/rentalAssetViewCss";
import {getDateAsString} from "../../../components/Utils/Utils";
import {OverviewType} from "../../../constant/CodeSpecNum";
import {BtnSearchBtn} from "../../../components/buttons/style/ButtonStyle";
import useRequestData from "../../../hooks/useRequestData";
import {selectServiceRequest} from "../../../api/serviceRequest/ServiceRequestService";
import TableMovable from "../../../components/table/movable/TableMovable";
import {SERVICE_REQUEST_HEADER} from "../../../components/table/header/Headers";
import CommonPagination from "../../../components/table/movable/CommonPagination";
import {useDispatch} from "react-redux";
import {apiLoading} from "../../../redux/slice/apiSlice";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {cn} from "../../../shadCn/lib/utils";
import Printer from "../../../resources/icon/pirnter-bw.png";

/** 요청 처리율 현황 */
const ServiceRequestHandlingOverview = () => {
    const initialData = {
        startDate: toKSTISOString(addMonths(new Date(), -2)),      // 2달전
        endDate: toKSTISOStringEnd(addMonths(new Date(), 0)),
        codeIds : []
    }
    const [search, setSearch] = useState(initialData);
    const [serviceRequestStatics, setServiceRequestsStatics] = useState([]);
    const [primeServiceCodes, setPrimeServiceCodes] = useState([]);
    const [checked, setChecked] = useState(true);

    const dispatch = useDispatch();

    useEffect(() => {
        handleCallData();
    }, []);

    const { data, pageInfo,dataHook} =
        useRequestData((conditions, pageable) => {
            const additionalCondition = {
                //진행단계가 50 초과인데이터 불러오기
                progressNumericValueOver50: true
            };
            const finalConditions = {
                ...conditions,
                ...additionalCondition
            };
            return selectServiceRequest(finalConditions, pageable);
        }, initialData, "handlingOverView");

    const handleCallData = async () => {
        dispatch(apiLoading(true));
        const response = await getHandlingOverview(search);
        if (response && response.status === 200) {
            const staticsData = response.data;
            setServiceRequestsStatics([...staticsData]);
            const codes = staticsData.map(code => ({id: code.primeId, name: code.name}));
            setPrimeServiceCodes([...codes]);
            const primeCodeIds = codes.map(code => code.id);
            setSearch((prev) => ({...prev, codeIds: [...primeCodeIds]}));
            dispatch(apiLoading(false));
        }
    }

    const getResult = (timelyDone, delayedDone) => {
        return parseInt(delayedDone) + parseInt(timelyDone) !== 0 ? timelyDone / (delayedDone + timelyDone) * 100 : 0
    }

    const getOverview = (timelyDone, delayedDone) => {
        const result = getResult(timelyDone, delayedDone);
        if (result === 0) return "";
        if (result >= 95) {
            return OverviewType.EXCELLENT.kor;
        } else if (result < 95 && result >= 85) {
            return OverviewType.OUTSTANDING.kor;
        } else if (result < 85 && result >= 75) {
            return OverviewType.AVERAGE.kor;
        } else if (result < 75 && result >= 65) {
            return OverviewType.INSUFFICIENT.kor;
        } else if (result < 65) {
            return OverviewType.POOR.kor;
        }
    }

    const handlePrimeCodeCheck = (id) => {
        /** check한 코드 id가 codeIds 에 포함되있다면 제거, 포함되지 않았다면 추가한다. */
        if (search.codeIds.includes(id)) {
            const list = search.codeIds;
            const filtered = list.filter(codeId => id !== codeId);
            setSearch(prev => ({...prev, codeIds: [...filtered]}));
        } else {
            const list = search.codeIds;
            list.push(id)
            setSearch(prev => ({...prev, codeIds: [...list]}));
        }
    }

    const handleOverviewSearch = async () => {
        dispatch(apiLoading(true));
        const response = await getHandlingOverview(search);
        if (response && response.status === 200) {
            dispatch(apiLoading(false));
            const staticsData = response.data;
            setServiceRequestsStatics([...staticsData]);
        }
        dataHook.handleSearch(search);
    }

    const handleAllCheck = () => {
        if (checked) {
            setSearch(prev => ({...prev, codeIds: []}));
        } else {
            const list = primeServiceCodes.map(e => e.id);
            setSearch(prev => ({...prev, codeIds: [...list]}));
        }

        setChecked(!checked);
    }

    return (
        <div className={"common-container container-height-full"}>
            <PageHeader header={"요청처리율현황"} indicator={"서비스요청 > 요청처리율현황"} />
            <SubContainer>
                <div>
                    <div>서비스요청 그룹</div>
                    <SubContainer className={'mt-2 flex flex-wrap'}>
                        <div className={'flex gap-2 mr-4 mb-1 max-w-[8rem] cursor-pointer'}>
                            <input
                                id={`check-all`}
                                type={`checkbox`}
                                checked={checked}
                                onChange={() => handleAllCheck()}
                                className={`ml-[5px]`}
                            />
                            <label htmlFor={`check-all`} className={'w-[6rem] truncate'}>전체선택</label>
                        </div>

                        {primeServiceCodes.length > 0 && primeServiceCodes.map((item, index) =>
                            <div key={`index-${index}`} className={'flex gap-2 mr-4 mb-1 max-w-[8rem] cursor-pointer'}>
                                <input
                                    id={`check-${index}`}
                                    type={`checkbox`}
                                    checked={search.codeIds.includes(item.id)}
                                    onChange={() => handlePrimeCodeCheck(item.id)}
                                    className={`ml-[5px]`}
                                />
                                <label htmlFor={`check-${index}`} className={'w-[6rem] truncate'}>{item.name}</label>
                            </div>
                        )}
                    </SubContainer>
                    <div className={'mt-4 flex gap-2'}>
                        <span className="mr-2 text-[12px] line-height-30">등록일시</span>
                        {/*<DatePeriod start={"startDate"} end={"endDate"} data={search} setData={setSearch}/>*/}
                        <div className={"web-flex"}>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setSearch, "startDate", v, false)}
                                data={search.startDate}
                                constraint={{lessThan: search.endDate && dayjs(search.endDate)}}
                                auth/>
                            <span className={cn("ml-2 mr-2 text-[20px]")}> ~ </span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setSearch, "endDate", v, false)}
                                data={search.endDate}
                                constraint={{largerThan: search.startDate && dayjs(search.startDate)}}
                                auth/>
                        </div>
                        <BtnSearchBtn display={'inline-block'} background={'#eeeded'} onClick={handleOverviewSearch}>상세검색</BtnSearchBtn>
                    </div>
                </div>
            </SubContainer>

            <div className={'my-5 flex justify-between'}>
                <div>
                    <div>1. 조회기간 내역</div>
                    <div>(진행 중인 요청을 제외한, 완료된 요청과 적기에 처리되지 않은 요청을 조회합니다.)</div>
                </div>
                <div className={'mr-2 print-none'}>
                    <abbr title={"인쇄하기"}>
                        <button className="mr-3" onClick={() => window.print()}>
                            <img src={Printer} className={`w-[30px] h-[30px] mt-[5px] border`}/>
                        </button>
                    </abbr>
                </div>
            </div>
            <SubContainer>
                <p className={`text-[1.5rem] text-center`}>서비스요청처리율</p>
                <div className={"mt-8"}>
                    대상기간 : {getDateAsString(false, search.startDate)} ~ {getDateAsString(false, search.endDate)}
                </div>
                <div className={"mt-8"}>
                    <span className={"mt-8"}>종합평가</span>
                    <CustomTable>
                        <tbody>
                        <tr>
                            <CustomTh background={'#f1f6f9'}>종합평가점수</CustomTh>
                            <CustomTh background={'#f1f6f9'}>95점 이상</CustomTh>
                            <CustomTh background={'#f1f6f9'}>85 ~ 95점 이상</CustomTh>
                            <CustomTh background={'#f1f6f9'}>75 ~ 85점 미만</CustomTh>
                            <CustomTh background={'#f1f6f9'}>65 ~ 75점 미만</CustomTh>
                            <CustomTh background={'#f1f6f9'}>65점 미만</CustomTh>
                        </tr>
                        <tr>
                            <CustomTh background={'#ffffff'} align={'center'}>평가등급</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>A(탁월)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>B(우수)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>C(보통)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>D(미흡)</CustomTh>
                            <CustomTh background={'#ffffff'} align={'center'}>E(불량)</CustomTh>
                        </tr>
                        </tbody>
                    </CustomTable>
                </div>
                <div className={'mt-8'}>
                    <span>종합평가</span>
                    <CustomTable>
                        <tbody>
                        <tr>
                            <CustomTh background={'#f1f6f9'} rowSpan={2}>구분</CustomTh>
                            <CustomTh background={'#f1f6f9'} rowSpan={2}>측정지표</CustomTh>
                            <CustomTh background={'#f1f6f9'} colSpan={2}>서비스수준</CustomTh>
                            <CustomTh background={'#f1f6f9'} colSpan={2}>실적</CustomTh>
                        </tr>
                        <tr>
                            <CustomTh background={'#ffffff'}>목표수준</CustomTh>
                            <CustomTh background={'#ffffff'}>최소수준</CustomTh>
                            <CustomTh background={'#ffffff'}>측정결과</CustomTh>
                            <CustomTh background={'#ffffff'}>평가점수</CustomTh>
                        </tr>
                        </tbody>
                        <tbody>
                        {serviceRequestStatics.length > 0 && serviceRequestStatics.map((service, index) =>
                            <React.Fragment key={`service-${index}`}>
                                <tr>
                                    <CustomTh rowSpan={5}>{service.name}</CustomTh>
                                    <CustomTh>적기처리율</CustomTh>
                                    {/* 목표수준 */}
                                    <CustomTh rowSpan={5}>{service?.targetLevel && OverviewType[service.targetLevel].kor}</CustomTh>
                                    {/* 최소수준 */}
                                    <CustomTh rowSpan={5}>{service?.minimumLevel && OverviewType[service.minimumLevel].kor}</CustomTh>
                                    {/* 측정결과 */}
                                    <CustomTh>{`${getResult(service.timelyDone, service.delayedDone)} %`}</CustomTh>
                                    {/* 평가점수 */}
                                    <CustomTh rowSpan={5}>{getOverview(service.timelyDone, service.delayedDone)}</CustomTh>
                                </tr>
                                <tr>
                                    <CustomTh>적기처리건수</CustomTh>
                                    <CustomTh>{service.timelyDone}</CustomTh>
                                </tr>
                                <tr>
                                    <CustomTh>지연처리건수</CustomTh>
                                    <CustomTh>{service.delayedDone}</CustomTh>
                                </tr>
                                <tr>
                                    <CustomTh>총 완료건수</CustomTh>
                                    <CustomTh>{service.timelyDone + service.delayedDone}</CustomTh>
                                </tr>
                                <tr>
                                    <CustomTh>총 요청건수</CustomTh>
                                    <CustomTh>{service.total}</CustomTh>
                                </tr>
                            </React.Fragment>
                        )}
                        </tbody>
                    </CustomTable>
                </div>
            </SubContainer>
            <div className={'my-5 print-none'}>
                <div>2. 조회기간 상세내역</div>
                <div>(진행 중인 요청을 제외한, 완료된 요청과 적기에 처리되지 않은 요청을 조회합니다.)</div>
            </div>
            <SubContainer className={'print-none'}>
                <div className={'min-h-[23rem]'}>
                    <TableMovable data={data} header={SERVICE_REQUEST_HEADER} page={pageInfo} url={'/serviceRequest/serviceRequest'} size={10}/>
                </div>
                <CommonPagination page={pageInfo} onPageChange={dataHook.handlePageChange}/>
            </SubContainer>
        </div>
    );
};

export default ServiceRequestHandlingOverview;